import React, { type PropsWithChildren } from 'react';

import { RouterProvider } from 'react-aria-components';
import { useHistory } from 'react-router-dom';

// TODO: when upgraded to react-router-dom v6,
// replace this module with the one from @flipdish/ui-library

declare module 'react-aria-components' {
  interface RouterConfig {
    routerOptions: {
      replace?: boolean;
      state?: unknown;
    };
  }
}

export const RouteProvider = ({ children }: PropsWithChildren) => {
  const history = useHistory();

  return (
    <RouterProvider
      navigate={(href, options) => {
        if (options?.replace) {
          history.replace(href, options?.state);
        } else {
          history.push(href, options?.state);
        }
      }}
      useHref={(href) => href}
    >
      {children}
    </RouterProvider>
  );
};
